import { ValidatorFn, FormControl, ValidationErrors } from '@angular/forms';

/**
 * Custom validator function that checks the length of a text input.
 * Returns a validation error if the length exceeds the specified maximum length.
 *
 * @param maxLength The maximum length allowed for the text input.
 * @returns A ValidatorFn function that can be used in Angular reactive forms.
 */
export const TextLengthValidator = (maxLength: number = 0): ValidatorFn => {
	return (control: FormControl): ValidationErrors | null => {
		if (!control.value || maxLength === 0) {
			return null;
		}

		return control.value.length > maxLength ? { lengthError: { valid: false } } : null;
	};
};
